var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2514 10.584L5.33398 10.584",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2507 6H5.33398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2511 1.41797H5.33398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54199 1.58398C2.54199 2.13627 2.09428 2.58398 1.54199 2.58398C0.989707 2.58398 0.541992 2.13627 0.541992 1.58398C0.541992 1.0317 0.989707 0.583984 1.54199 0.583984C2.09428 0.583984 2.54199 1.0317 2.54199 1.58398Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54199 6.00195C2.54199 6.55424 2.09428 7.00195 1.54199 7.00195C0.989707 7.00195 0.541992 6.55424 0.541992 6.00195C0.541992 5.44967 0.989707 5.00195 1.54199 5.00195C2.09428 5.00195 2.54199 5.44967 2.54199 6.00195Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54199 10.418C2.54199 10.9703 2.09428 11.418 1.54199 11.418C0.989707 11.418 0.541992 10.9703 0.541992 10.418C0.541992 9.86568 0.989707 9.41797 1.54199 9.41797C2.09428 9.41797 2.54199 9.86568 2.54199 10.418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewWhiteIcon);
export default __webpack_public_path__ + "static/media/list-view-white-icon.bcaa21e83f421f634f538fc19213605e.svg";
export { ForwardRef as ReactComponent };